var map = {
	"./ACTIVE_DIRECTORY.png": 1565,
	"./ADP.png": 1566,
	"./AIRTABLE.png": 1567,
	"./BAMBOOHR.png": 1568,
	"./CSV.png": 597,
	"./EXCEL.png": 598,
	"./GOOGLE_DRIVE.png": 1569,
	"./GOOGLE_SHEETS.png": 599,
	"./GUSTO.png": 1570,
	"./HIBOB.png": 1571,
	"./KRONOS.png": 1572,
	"./MICROSOFT_TEAMS.png": 1573,
	"./NAMELY.png": 1574,
	"./ORACLE.png": 1575,
	"./PAYCHEX.png": 1576,
	"./PAYCOM.png": 1577,
	"./PAYLOCITY.png": 1578,
	"./RIPPLING.png": 1579,
	"./SAGE_PEOPLE.png": 1580,
	"./SALESFORCE.png": 1581,
	"./SAP_SUCCESS_FACTORS.png": 1582,
	"./SHAREPOINT.png": 1583,
	"./SLACK.png": 1584,
	"./TRINET.png": 1585,
	"./ULTIPRO.png": 1586,
	"./WORKDAY.png": 1587,
	"./ZENEFITS.png": 1588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1564;